import { Col, Row, Badge, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import CardOffice from "./CardOffice/cardOffice";
import Loading from "../../../commons/components/loading";
import ServiceOffice from '../../../services/offices';
import urlParameters from "../../../commons/utils/urlParameters";

export default ({ userData }) => {
    const [officeList, setOfficeList] = useState();
    const [depList, setDepList] = useState();
    const [fullPartnersList, setFullPartnersList] = useState();
    const [userOffices, setUserOffices] = useState();

    const [allowedPartnerList, setAllowedParnerList] = useState([]);

    const [loading, setLoading] = useState(true);
    const [showLoading, setShowLoading] = useState(true)

    const [creating, setCreating] = useState(false);
    const [editing, setEditing] = useState(false);

    const [officeDepLoaded, setOfficeDepLoaded] = useState(false);
    const [userOfficesLoaded, setUserOfficesLoaded] = useState(false);

    const [showProfessionalData, setShowDadosProfissionais] = useState(false);

    const showUpdateProData = () => {
        let url = window.location.href;
        let parameters = urlParameters(url);
        if (parameters["atualizar-dados-profissionais"] === "true") {
            return true;
        }
        return null;
    }

    useEffect(() => {
        if (userData.id) {
            setShowLoading(true);
            getLists(userData.id);
            getOfficesUser(userData.id);

            const url = window.location.href;
            const parameters = urlParameters(url);
            if (parameters["atualizar-dados-profissionais"] === "true") {
                setCreating(true);
            }
        }
    }, [])

    useEffect(() => {
        if (officeDepLoaded && userOfficesLoaded) {
            processData();
            setLoading(false);
        }
    }, [officeDepLoaded, userOfficesLoaded])

    useEffect(() => {
        if (loading == true) {
            setUserOfficesLoaded(false);
            setOfficeDepLoaded(false);
            setShowLoading(true);
            getLists(userData.id);
            getOfficesUser(userData.id);
        } else {
            setShowLoading(false);
        }
    }, [loading])

    function reload() {
        setLoading(true);
        setCreating(false);
        if (showUpdateProData) {
            window.location.href = '/dadospessoais'
        }
    }

    async function getOfficesUser(id_user) {
        let response = await ServiceOffice.getOfficesUser(id_user);
        if (response) {
            setUserOffices(response.data.data);
        } else {
            setUserOffices([]);
        }
        setUserOfficesLoaded(true);
    }

    async function getLists(id_user) {
        let response = await ServiceOffice.getOfficesDeps(id_user);
        if (response) {
            transformDataLists(response.data.data)
            setOfficeDepLoaded(true);
        }
    }

    function transformDataLists(data) {
        let optionsOffice = [];
        let optionsDep = [];

        if (data.offices) {
            for (let i = 0; i < data.offices.length; i++) {
                optionsOffice.push({ value: data.offices[i].id, label: data.offices[i].name });
            }
        }

        if (data.departments) {
            for (let i = 0; i < data.departments.length; i++) {
                optionsDep.push({ value: data.departments[i].id, label: data.departments[i].name });
            }
        }

        setOfficeList(optionsOffice);
        setDepList(optionsDep);

        if (data.partners) {
            let partnerList = [];
            let onlyDefault = true;
            for (let i = 0; i < data.partners.length; i++) {
                if (data.partners[i].id != 1) {
                    onlyDefault = false;
                }
                partnerList.push({ value: data.partners[i].id, label: data.partners[i].trading_name });
            }
            setFullPartnersList(partnerList);
            if (partnerList.length > 0 || !onlyDefault) {
                setShowDadosProfissionais(true);
            }
        }
    }

    function processData() {
        let usedPartner = [];
        let allowedPartners = [];
        if (userOffices != null && userOffices.length > 0) {
            for (let i = 0; i < userOffices.length; i++) {
                usedPartner.push(userOffices[i].id_partner);
            }
        }
        for (let i = 0; i < fullPartnersList.length; i++) {
            let found = usedPartner.find(function (part, index) {
                if (part == fullPartnersList[i].value)
                    return true;
            });
            if (found == null) {
                allowedPartners.push(fullPartnersList[i]);
            }
        }
        setAllowedParnerList(allowedPartners);
    }

    function canEdit() {
        if (creating || editing) {
            return false;
        }
        return true;
    }

    function officesLeft() {
        return allowedPartnerList.length;
    }

    function create() {
        setCreating(true);
    }

    function renderNewButton() {
        if (!showLoading) {
            let officesLeftCount = officesLeft();
            if (officesLeftCount != 0 && !creating) {
                let textTooltip = "Há empresa(s) vinculada(s) a você sem os dados de cargo e setor preenchidos.";
                return (
                    <Tooltip placement="left" title={textTooltip}>
                        <Badge count={officesLeftCount}>
                            <button className={"account-button account-button-default account-button-effect"} onClick={create}>Nova atuação</button>
                        </Badge>
                    </Tooltip>
                )
            } else {
                return null;
            }
        }
    }

    function renderCards() {
        if (showLoading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <>
                    {userOffices.map(item => (
                        <CardOffice item={item}
                            user={item.id_user}
                            key={item.id}
                            canEdit={canEdit()}
                            reload={() => {
                                reload();
                            }}
                            editing={(e) => {
                                setEditing(e);
                                if (!e) {
                                    setCreating(e);
                                }
                            }}
                            officeList={officeList}
                            depList={depList}
                            partnerList={allowedPartnerList} />
                    ))}
                </>
            )
        }
    }

    function renderNew() {
        if (!showLoading && creating && officesLeft() != 0) {
            return (
                <CardOffice key={0}
                    creating={true}
                    user={userData.id}
                    reload={() => {
                        reload();
                    }}
                    editing={(e) => {
                        setEditing(e);
                        if (!e) {
                            setCreating(e);
                        }
                    }}
                    officeList={officeList}
                    depList={depList}
                    partnerList={allowedPartnerList} />
            )
        }
    }

    function renderProfessionalData() {
        if (showProfessionalData) {
            return (
                <div>
                    <Row style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: 42,
                    }}>
                        <Col span={12}>
                            <h3 className={"dados-subheader"}>Dados Profissionais</h3>
                        </Col>
                        <Col span={12}>
                            <div style={{ textAlign: "end" }}>
                                {renderNewButton()}
                            </div>
                        </Col>
                    </Row>
                    {renderNew()}
                    {renderCards()}
                </div>
            )
        } else return null
    }

    return renderProfessionalData();
}
